import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Revele from '../components/Revele';
import Besoin from '../components/Besoin';
import Processus from '../components/Processus';
import { Fleche } from '../components/Fleche';
import { useLangue } from '../i18n/LangueContext';

const majuscule = (s) => s.charAt(0).toUpperCase() + s.slice(1);

const Accueil = () => {
  const { t } = useLangue();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const ancre = location.state && location.state.ancre;
    if (ancre) {
      const el = document.getElementById(ancre);
      if (el) {
        window.setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 60);
      }
      navigate('/', { replace: true, state: {} });
    }
  }, [location.state, navigate]);

  const versBesoin = (e) => {
    e.preventDefault();
    const el = document.getElementById('besoin');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <main id="principal">
      <section className="hero">
        <div className="conteneur">
          <p className="surtitre">{t.hero.surtitre}</p>
          <h1>{t.hero.titre}</h1>
          <div className="hero-corps">
            <p className="chapeau">{t.hero.chapeau}</p>
            <div className="hero-actions">
              <Link to="/demander-un-acces" className="btn btn-plein">
                {t.hero.cta1} <Fleche />
              </Link>
              <a href="/#besoin" className="btn btn-ligne" onClick={versBesoin}>{t.hero.cta2}</a>
            </div>
          </div>
        </div>
      </section>

      <div className="bandeau" aria-hidden="true">
        <div className="piste">
          {[...t.secteurs, ...t.secteurs].map((s, i) => (
            <span key={`${s}-${i}`}>{s}</span>
          ))}
        </div>
      </div>

      <section>
        <div className="conteneur">
          <div className="duo">
            <div><p className="chapeau">{t.intro[0]}</p></div>
            <div><p>{t.intro[1]}</p></div>
          </div>
        </div>
      </section>

      <section id="sources" className="sur-blanc">
        <div className="conteneur">
          <Revele className="tete-section">
            <h2>{t.sources.titre}</h2>
          </Revele>
          <div className="duo">
            {t.sources.cartes.map((c) => (
              <Revele as="article" className="carte" key={c.titre}>
                <h3>{c.titre}</h3>
                {c.paragraphes.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
              </Revele>
            ))}
          </div>
        </div>
      </section>

      <section id="besoin">
        <div className="conteneur">
          <Revele className="tete-section">
            <h2>{t.besoin.titre}</h2>
            <p className="chapeau">{t.besoin.chapeau}</p>
          </Revele>
          <Besoin />
        </div>
      </section>

      <section id="activites" className="sur-blanc">
        <div className="conteneur">
          <Revele className="tete-section">
            <h2>{t.activites.titre}</h2>
            <p className="chapeau">{t.activites.chapeau}</p>
          </Revele>
          <Revele className="taches">
            {t.taches.map((x) => (
              <div className="tache" key={x}>
                <div className="n">{majuscule(x)}</div>
              </div>
            ))}
          </Revele>
          <p className="chapeau" style={{ marginTop: '2rem' }}>{t.activites.note}</p>
        </div>
      </section>

      <section id="processus">
        <div className="conteneur">
          <Revele className="tete-section">
            <h2>{t.processus.titre}</h2>
          </Revele>
          <Processus />
        </div>
      </section>

      <section id="partenaire" className="sur-appui">
        <div className="conteneur">
          <Revele className="tete-section" style={{ marginBottom: 'clamp(2rem,3.5vw,2.8rem)' }}>
            <h2>{t.partenairePage.titre}</h2>
            <p className="chapeau" style={{ marginTop: '1rem' }}>{t.partenairePage.chapeau}</p>
          </Revele>
          <div className="partenaire">
            <Revele>
              {t.partenairePage.colonne1.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </Revele>
            <Revele>
              {t.partenairePage.colonne2.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
              <p className="accent-phrase">{t.partenairePage.accent}</p>
              <Link to="/devenir-partenaire" className="btn btn-plein" style={{ marginTop: '1.6rem' }}>
                {t.partenairePage.cta} <Fleche />
              </Link>
            </Revele>
          </div>
        </div>
      </section>

      <section>
        <div className="conteneur">
          <div className="duo">
            <Revele>
              <h3 style={{ fontSize: 'clamp(1.4rem,2.2vw,1.75rem)', marginBottom: '1.15rem' }}>{t.enrichissement.titre1}</h3>
              {t.enrichissement.p1.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </Revele>
            <Revele>
              <h3 style={{ fontSize: 'clamp(1.4rem,2.2vw,1.75rem)', marginBottom: '1.15rem' }}>{t.enrichissement.titre2}</h3>
              <p>{t.enrichissement.p2intro}</p>
              <ul className="liste-fine">
                {t.enrichissement.liste.map((l) => (
                  <li key={l}>{l}</li>
                ))}
              </ul>
              {t.enrichissement.apres.map((p, i) => (
                <p key={i} style={i === 0 ? { marginTop: '1.4rem' } : undefined}>{p}</p>
              ))}
            </Revele>
          </div>
        </div>
      </section>

      <section id="engagements" className="sur-blanc">
        <div className="conteneur">
          <Revele className="tete-section">
            <h2>{t.engagementsTitre}</h2>
          </Revele>
          <Revele className="engagements">
            {t.engagements.map((e) => (
              <div className="engagement" key={e.titre}>
                <h3>{e.titre}</h3>
                <p>{e.texte}</p>
              </div>
            ))}
          </Revele>
        </div>
      </section>

      <section id="acces">
        <div className="conteneur">
          <Revele className="tete-section">
            <h2>{t.acces.titre}</h2>
            <p className="chapeau">{t.acces.chapeau}</p>
          </Revele>
          <Revele className="actions">
            {t.acces.actions.map((a) =>
              a.to.startsWith('/#') ? (
                <a className="action" href={a.to} key={a.titre} onClick={versBesoin}>
                  <h3>{a.titre}</h3>
                  <p style={{ fontSize: '.95rem' }}>{a.texte}</p>
                  <span className="go">{a.go} <Fleche /></span>
                </a>
              ) : (
                <Link className="action" to={a.to} key={a.titre}>
                  <h3>{a.titre}</h3>
                  <p style={{ fontSize: '.95rem' }}>{a.texte}</p>
                  <span className="go">{a.go} <Fleche /></span>
                </Link>
              )
            )}
          </Revele>
        </div>
      </section>
    </main>
  );
};

export default Accueil;
